export default "__VITE_ASSET__Dh_W0ndM__"